import React from 'react';
import { Modal, Form, Input, Col, Card, Row, Select } from 'antd';
import ValidatorHelper from '../helpers/ValidatorHelper';
import StringHelper from '../helpers/StringHelper';
import UserServices from '../../services/UserServices';
import { usePersistedStore } from '../../store/persisted-store';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';

export default function AddUserAgentWage({ userId }) {
    const { business, GET_USER_AGENT_WAGE } = usePersistedStore()
    const general = useGeneralStore();

    const visible = general.view.userAddAgentWageModal;
    const branches = business.branchNames.data;
    const branchesLoading = business.branchNames.loading;
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
    const [form] = Form.useForm();

    function onAddUserAgentWageFinish(values) {

        UserServices.postUserAgentWage({
            UserId: userId,
            BranchId: values.BranchId,
            WagePercent: parseFloat(StringHelper.getEnglishNum(values.WagePercent)),
            WagePrice: parseInt(values.WagePrice)
        }, token).then((res) => {
            getUserAgentWage(userId)
            general.NotifSuccess('با موفقیت ثبت شد');
            form.resetFields()
            general.ToggleUserAddAgentWage()
        }).catch((error) => {

        })
    }
    function getUserAgentWage(recordId) {
        UserServices.getUserAgentWage(recordId, token).then((res) => {
            GET_USER_AGENT_WAGE(res.data)
        }).catch((error) => {

        })
    }
    return (
        <Modal
            width='60%'
            title="افزودن کارمزد کاربر"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleUserAddAgentWage()}>
            <Row gutter={24} justify="space-around" style={{ paddingTop: 20 }}>
                <Col span={24}>
                    <Card size="small" >
                        <Form form={form} onFinish={onAddUserAgentWageFinish}>
                            <Row gutter={24}>
                                <Col span={7}>
                                    <Form.Item
                                        name="BranchId"
                                        rules={ValidatorHelper.required('رشته')}
                                        label="رشته">
                                        <Select disabled={branchesLoading} loading={branchesLoading}>
                                            {branches && branches.map(branch => <Select.Option key={branch.Id} value={branch.Id}>{branch.Title}</Select.Option>)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item
                                        name='WagePercent'
                                        label='درصد کارمزد'
                                        rules={[
                                            ...ValidatorHelper.decimalNumber('درصد کارمزد')
                                        ]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={7}>
                                    <Form.Item name='WagePrice' label='مبلغ کارمزد'
                                        rules={[
                                            ...ValidatorHelper.number('مبلغ کارمزد')
                                        ]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={3}>
                                    <Form.Item>
                                        <button type="primary" htmltype="submit" className="btn btn-primary waves-effect waves-light" style={{ display: "flex" }}>
                                            <i className="bx bx-check-double font-size-16 align-middle mr-2"></i> ثبت
                                        </button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </Modal >
    )
}

